import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <main style={{ padding: '2rem' }}>
      <h1>404 — Page Not Found</h1>
      <Link to="/">Go to Dashboard</Link>
    </main>
  );
}
